import Vue from 'vue'
import 'normalize.css/normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import VCharts from 'v-charts'
import '@/styles/index.scss'
import App from './App'
import router from './router'
import store from './store'
import '@/icons'
import '@/permission'
import echarts from "echarts";
Vue.prototype.$echarts = echarts;

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

// 使用新版本的注册方式
// 确保 Vue-Quill-Editor 的正确引入方式（新版本可能需要单独引入样式）
import VueQuillEditor from 'vue-quill-editor'

// 确保quill样式和polyfill正确引入
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 添加缺失的mutationobserver-shim导入（若未生效）
import 'mutationobserver-shim'

Vue.use(VueQuillEditor)

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js